export const commonLabelName = {
    cancel: 'Cancel',
    submit: 'Submit',
    minus: '-',
    plus: '+',
    export: 'Export',
    exportAsPdf: 'Export as PDF',
    exportAsCsv: 'Export as CSV',
    exportAll: 'Export All',
    noData: 'No data available',
    noInternet: 'No Internet Connection',
    refresh: 'Refresh',
    csv: 'CSV',
    pdf: 'PDF',
    noRecordFound: 'No records found.',
    confirm: 'Confirm',
    email: 'email',
    username: 'Username',
    emailAddress: 'Email Address',
    send: 'Send',
    password: 'Password',
    rememberMe: 'rememberMe',
    login: 'Login',
    academic: 'ACADEMIC',
    commercial: 'COMMERCIAL',
    training: 'TRAINING',
    device: 'device',
    ForgotUsernameOrEmail: 'Forgot Username/Email Address',
    forgotPassword: 'Forgot Password',
    register: 'Register',
    confirmPassword: 'ConfirmPassword',
    city: 'City',
    total: 'Total',
    loading: 'Loading...',
    paymentRelatedQueries:
        'Please contact geospatialsupport@nv5.com or your sales representative for any order or payment related queries.',
    proceed: 'Proceed',
    noDataFound: 'No data found',
    contactUs: 'Contact Us',
    pageNotFound: 'Page not found ',
    evaluation: 'Evaluations'
}

export const pathName = {
    signIn: '/auth/sign-in',
    verifyUser: '/auth/verify-user',
    studentLicenses: '/student-licenses',
    commercialLicenses: '/commercial-licenses',
    trainingCourses: '/training-courses',
    homePage: '/',
    forgotUsername: '/auth/forgot-username-or-email',
    forgotPassword: '/auth/forgot-password',
    signUp: '/auth/sign-up',
    contactUs: `https://www.nv5geospatialsoftware.com/Company/Contact-Us`
}

export const commonErrorMessage = {
    accessDenied: `Access denied, you are not authorized to access the customer portal. If you have recently registered, a manual security screening is required which may take up to 24 hours to complete. Please try again later.\nIf you continue to have login issues, please contact geospatialsupport@nv5.com or your sales representative.`
}

export const loginWarningContent = {
    warningContent:
        "Recent Login Change: If your previous Username/Email Address & Password fails and you haven't logged in since 2024, please select “Register” below."
}
